.z{overflow:hidden;}